export default __webpack_public_path__ + "img/wechatQR-link.415e740f.svg";